<template lang="pug">
.vue-time-entries-different-time-zone-warning.form-group.help.time-zone(v-show="!computedSameTz")
  .hi.hi-important.hi-16
  | {{ warning }}
</template>
<script>
import { mapGetters } from 'vuex';
import { formatDatetime, formatDate } from '~/utils/time_utils';

export default {
  name: 'TimeEntriesDifferentTimeZoneWarning',
  props: {
    datetimeRange: {
      default: null,
    },
    // customUser customUserZone and customSameTz are props to use when we don't
    // want to access the Vuex getters
    // This is used in the View Manual Time Request dialog.
    customUser: {
      type: Object,
      default: null,
    },
    customUserZone: {
      type: Object,
      default: null,
    },
    customSameTz: {
      type: Boolean,
      default: null,
    }
  },
  computed: {
    ...mapGetters(['sameTz', 'user', 'userZone']),

    computedSameTz() {
      return this.customSameTz !== null ? this.customSameTz : this.sameTz;
    },

    computedUser() {
      return this.customUser || this.user;
    },

    computedUserZone() {
      return this.customUserZone || this.userZone;
    },

    formattedDatetimeRange() {
      if (this.datetimeRange && this.computedUserZone) {
        const userStart = this.datetimeRange.start.clone().tz(this.computedUserZone.name);
        const userStop = this.datetimeRange.stop.clone().tz(this.computedUserZone.name);
        const hasDifferentDay =
          formatDate(userStart) !== formatDate(this.datetimeRange.start) ||
          formatDate(userStop) !== formatDate(this.datetimeRange.stop);
        const formattedStart = this.formattedDatetime(userStart, hasDifferentDay);
        const formattedStop = this.formattedDatetime(userStop, hasDifferentDay);

        return `${formattedStart} - ${formattedStop}`;
      }

      return '';
    },
    warning() {
      return `This is ${this.formattedDatetimeRange} in ${this.computedUser ? this.computedUser.name : ''}'s time zone.`;
    },
  },
  methods: {
    formattedDatetime(datetime, showMonth) {
      let formattedDatetime = formatDatetime(datetime, { style: 'time', showSeconds: 'auto' });
      const monthDayFormat = 'MMM D';

      if (showMonth) {
        formattedDatetime += ` (${datetime.format(monthDayFormat)})`;
      }

      return formattedDatetime;
    },
  },
};
</script>
